import React, { useImperativeHandle } from "react";
import { useRequest, useUpdateEffect } from "ahooks";
import { useGlobalState } from "@/GlobalProvider";
import { useTranslation } from "@/langs/useTranslation";
import { getAlarmDeviceDeployerList } from "@/apis/apiCollection";
import SingleSelector from "../SingleSelector";

const DeployMembers = React.forwardRef(
  ({ disabled, name, value, onChange }, ref) => {
    const { t } = useTranslation();
    const { currentCompanyId } = useGlobalState();
    const { data = { AlarmDeviceDeployers: [] }, run } = useRequest(
      getAlarmDeviceDeployerList
    );

    useUpdateEffect(run, [currentCompanyId]);

    useImperativeHandle(ref, () => ({
      getOptions: () => data.AlarmDeviceDeployers
    }));

    return (
      <SingleSelector
        placeholder={t({ defaultMessage: "选择部署人" })}
        options={data.AlarmDeviceDeployers}
        clearable
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
      />
    );
  }
);

export default DeployMembers;
